import Entity from './entity'

const Broker = new Entity('brokers')

export default Broker
